import Vector from './Vector';
import * as PCConstants from '../PCConstants';

export enum AlternativeNodeColour {
  DEFAULT = '',
  DELETE = 'delete',
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  TONNAGE = 'tonnage',
}

// A node is coordinates plus its own attributes. Adjacency, edge pipe, flow direction, choke length,
// throughput history and inspection points all live on the spool; `pipeId` remains only as the
// fallback pipe for edges created from this node. Named options rather than positional arguments so
// a wholesale rebuild reads as data.
export interface PCNodeOptions {
  coords: Vector;
  id: string;
  pipeId: string;
  nodeName?: string;
  isStope?: boolean;
  isPit?: boolean;
  isPlantNode?: boolean;
  area?: string;
  level?: string;
  pit?: string;
  boosterPressure?: number;
  ruptureDiskPressure?: number;
  chokeHead?: number;
  nodeColour?: string;
  nodeSize?: number;
  isManuallyAdded?: boolean;
}

export default class PCNode {
  coords: Vector;

  pipeId: string;

  isStope: boolean;

  isPit: boolean;

  isRequired: boolean = false;

  isPlantNode: boolean;

  id: string;

  nodeName: string;

  area?: string;

  level?: string;

  pit?: string;

  boosterPressure = 0;

  ruptureDiskPressure = 0;

  chokeHead = 0;

  nodeColour: string;

  nodeSize: number;

  showConstraintArrow: boolean;

  isManuallyAdded: boolean;

  constructor({
    coords,
    id,
    pipeId,
    nodeName,
    isStope,
    isPit,
    isPlantNode,
    area,
    level,
    pit,
    boosterPressure,
    ruptureDiskPressure,
    chokeHead,
    nodeColour,
    nodeSize,
    isManuallyAdded,
  }: PCNodeOptions) {
    this.coords = new Vector(coords.x, coords.y, coords.z);
    this.id = id;
    this.nodeName = nodeName || id;
    this.pipeId = pipeId; // fallback pipe for edges seeded from this node
    this.isStope = isStope || false;
    this.isPit = isPit || false;
    this.area = area;
    this.level = level;
    this.pit = pit;
    this.boosterPressure = boosterPressure || 0;
    this.ruptureDiskPressure = ruptureDiskPressure || 0;
    this.chokeHead = chokeHead || 0;
    this.isPlantNode = isPlantNode || false;
    this.nodeColour = nodeColour ?? PCConstants.NODE_COLOUR;
    this.nodeSize = nodeSize ?? PCConstants.NODE_RADIUS;
    this.showConstraintArrow = false;
    this.isManuallyAdded = isManuallyAdded || false;
  }
}
